import {ReactComponent as ProfileIcon} from './profile.svg'

function Profile() {
  return <ProfileIcon />
}

export default Profile
